/*
 * @Author: 肖玲
 * @Date: 2023-02-28 16:21:10
 * @LastEditTime: 2023-02-28 18:42:00
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-import\modules\uploadRecordRouter.js
 * 上传记录
 */
const uploadRecordRouter = [
  // 上传记录
  {
    path: '/flowSystem/fs-upload-page',
    name: 'flowSystemUploadLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem1" */
      //   '@/views/flowSystem/UploadLog.vue'
      // ),    待删除文件
    import(
      /*webpackChunkName:"flowSystem1" */
      '@/views/butterfly-flow-system/flow-direction-import/upload-record/upload-record/Page.vue'
    ),  //新迁移文件
    meta: {
      SecondaryMenu: '上传记录', //二级菜单
      title: '上传记录',
    },
  },
  // 数据明细 type 待处理数据,待入库数据,上传记录
  {
    path: '/flowSystem/fs-file-detail/:id/:type/:meta_type/:data_attr',
    name: 'flowSystemUploadFileContent',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem1" */
      //   '@/views/flowSystem/UploadFileContent.vue'
      // ),  待删除文件
    import(
      /*webpackChunkName:"flowSystem1" */
      '@/views/butterfly-flow-system/flow-direction-import/upload-record/upload-record/Detail.vue'
    ),  //新迁移文件
    meta: {
      SecondaryMenu: '智能清洗', //二级菜单
      isMoreMeta: true,
      1: {
        title: '数据明细',
        breadcrumb: [{
          title: '待处理',
          name: 'flowSystemPendingTable',
          type: 1,
        }, ],
      },
      2: {
        title: '数据明细',
        breadcrumb: [{
          title: '待入库',
          name: 'flowSystemPendingInFlow',
          type: 2,
        }, ],
      },
      3: {
        title: '数据明细',
        breadcrumb: [{
          title: '上传记录',
          name: 'flowSystemUploadLog',
          type: 3,
        }, ],
      },
      4: {
        title: '数据明细',
        breadcrumb: [{
          title: '数据采集日志',
          name: 'flowSystemDirectLog',
          type: 4,
        }, ],
      },
      5: {
        title: '数据明细',
        breadcrumb: [{
          title: '待核验',
          name: 'flowSystemPendingCheck',
          type: 5,
        }, ],
      },
    },
  },
  // 手动上传记录
  {
    path: '/flowSystem/handle-upload-log',
    name: 'flowSystemHandleUploadLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem1" */
      //   '@/views/flowSystem/Handle-upload-log.vue'
      // ),  待删除文件
    import(
      /*webpackChunkName:"flowSystem1" */
      '@/views/butterfly-flow-system/flow-direction-import/upload-record/manually-upload-record/Page.vue'
    ),    //新迁移文件
    meta: {
      SecondaryMenu: '手动上传记录', //二级菜单
      title: '手动上传记录',
    },
  },
  // 原始上传文件记录
  {
    path: '/flowSystem/original-upload-page',
    name: 'flowSystemOriginalUploadLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem1" */
      //   '@/views/flowSystem/originalUploadLog.vue'
      // ),   待删除文件
    import(
      /*webpackChunkName:"flowSystem1" */
      '@/views/butterfly-flow-system/flow-direction-import/upload-record/original-upload-record/Page.vue'
    ),   //新迁移文件
    meta: {
      SecondaryMenu: '上传记录', //二级菜单
      title: '原始上传文件记录',
    },
  },
]
export default uploadRecordRouter